import { DataLayerEventStack } from '@wkda/data-layer';
import { useConstant } from '@wkda/funnel-components';
import { CarleadDataLayer } from '@wkda/funnel-data-layers';
import { useEffect, useRef } from 'react';
import { useCarleadConfiguration } from './useCarleadCreationConfiguration';
export function useCarleadDataLayer() {
  let DataLayerClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CarleadDataLayer;
  const {
    fullLocale
  } = useCarleadConfiguration();
  const dataLayer = useRef(DataLayerClass.getInstance());
  const locale = useConstant(() => fullLocale);
  useEffect(() => {
    const dataLayerEventStack = new DataLayerEventStack();
    dataLayerEventStack.init();
    dataLayer.current.init({
      locale
    });
  }, [locale]);
  return dataLayer.current;
}